const ICP_RECORDS = {
  "www.inner.dibox.com.cn": "闽ICP备19013696号-6",
  "inner.dibox.com.cn": "闽ICP备19013696号-6",
  "www.inner.chip-nova.cn": "闽ICP备19013696号-5",
  "inner.chip-nova.cn": "闽ICP备19013696号-5",
};

// 备案号绑定的是当前访问的网站域名，不跟登录页里选择的接口服务器联动。
const DEFAULT_ICP_RECORD = "闽ICP备19013696号-5";

function getHostname() {
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.hostname.toLowerCase();
}

export function getIcpRecord() {
  return (
    process.env.VUE_APP_ICP_RECORD ||
    ICP_RECORDS[getHostname()] ||
    DEFAULT_ICP_RECORD
  );
}

export function getIcpText(prefix = "备案号：") {
  return `${prefix}${getIcpRecord()}`;
}
